export default __webpack_public_path__ + "img/cyZwFdYs.eb02280d.svg";